import * as React from 'react';
import * as DTOS from "../../FeralScan.dtos";
import * as classNames from "classnames";
import { withTheme } from '../../common/withTheme';
import InternalClassificationLink from '../Framework/Common/Links/InternalClassificationLink';
import { LocalForm, Control } from 'react-redux-form';
import Loader from 'react-loaders';
import * as UserActionCreators from "../../actions/user.actions";
import * as LoginActionCreators from "../../actions/login.actions";

export interface IUserProfileFormItem {
    maxLength?: number;
    model: string;
    required: boolean;
    title: string;
    userProp: string;
}

interface IUserProfileProps {
    className?: string;
    theme?: string;
    user: DTOS.User;
    loginActive: boolean;
    saving?: boolean;

    formItems?: IUserProfileFormItem[];
    formItemClassName?: string;
    formItemLabelClassName?: string;
}

interface IUserProfileActions {
    login: typeof LoginActionCreators.login;
    logout: typeof LoginActionCreators.logout;
    updateUser: typeof UserActionCreators.updateUser;
}

type UserProfilePropsAndActions = IUserProfileProps & IUserProfileActions;

interface IUserProfileState {
    editMode: boolean;
}

class UserProfile extends React.PureComponent<UserProfilePropsAndActions, IUserProfileState> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            editMode: false
        }

        this.editProfile = this.editProfile.bind(this);
    }

    editProfile() {
        this.setState({ editMode: true })
    }

    onSubmit(user) {
        this.setState({ editMode: false })
        this.props.updateUser(user);
    }

    render() {

        const formItems = this.props.formItems ? this.props.formItems.map((item, i) => {
            return [
                <label key={`form-item-${i}-title`} className={classNames(this.props.formItemLabelClassName)}>{item.title}{item.required ? '*' : ''}</label>,
                <Control.text
                    key={`form-item-${i}-input`}
                    model={item.model}
                    id={item.model}
                    className={classNames(this.props.formItemClassName, "form-control")}
                    maxLength={item.maxLength}
                    required={item.required}
                    disabled={!this.state.editMode}
                    defaultValue={this.props["user"][item.userProp]}
                />
            ];
        }) : undefined;

        const userForm = <LocalForm
            model="user"
            onSubmit={user =>
                this.onSubmit(user)
            }
            //getDispatch={dispatch => { this.formDispatch = dispatch; dispatch(actions.load('user', this.props.item)); }}
            validateOn="submit"
            className="form form-group"
        >
            <label className={classNames(this.props.formItemLabelClassName)}>First Name</label>
            <Control.text
                model=".fullName"
                id="fullName"
                className={classNames(this.props.formItemClassName, "form-control")}
                maxLength={100}
                required={true}
                disabled={!this.state.editMode}
                defaultValue={this.props.user.fullName}
            />

            <label className={classNames(this.props.formItemLabelClassName)}>Surname</label>
            <Control.text
                model=".surname"
                id="surname"
                className={classNames(this.props.formItemClassName, "form-control")}
                maxLength={100}
                required={true}
                disabled={!this.state.editMode}
                defaultValue={this.props.user.surname}
            />

            <label className={classNames(this.props.formItemLabelClassName)}>Email</label>
            <Control.text
                model=".email"
                id="email"
                className={classNames(this.props.formItemClassName, "form-control")}
                maxLength={100}
                required={true}
                disabled={!this.state.editMode}
                defaultValue={this.props.user.email}
            />

            {formItems}

            {
                this.state.editMode ?
                    <button className="btn btn-primary mt-2" disabled={this.props.saving}>Save Changes</button>
                    : undefined
            }
        </LocalForm>;

        return (
            <div className={classNames(this.props.className, "card")}>
                <div className="card-body">
                    <h4 className="card-title">My User Details</h4>
                    {
                        this.props.saving ? <div className="position-absolute ml-4 ml-md-5 my-5"
                            style={{ opacity: 0.75, zIndex: 80, bottom: '15px' }}>
                            <Loader type="ball-scale-multiple" active />
                            <div className="ml-4 small">please wait, saving changes</div>
                        </div> : userForm
                    }
                    {
                        !this.state.editMode && !this.props.saving ?
                            <div className="d-flex flex-column flex-md-row justify-content-between mt-2">
                                <button className="btn btn-secondary" onClick={this.editProfile}>Edit Details</button>
                                {InternalClassificationLink("user/passwordreset", "Change Password", undefined, `${this.props.theme} btn btn-primary`)}
                            </div>
                            : undefined
                    }
                </div>
            </div>
        );
    }
}

export default withTheme<UserProfilePropsAndActions>(UserProfile);